import { ILeagueConfig } from 'fitbeat.models';

export const DEFAULT_LEAGUE_CONFIGS: ILeagueConfig[] = [
  { id: 'red', displayName: 'Red League', primaryColour: '#F00A23' },
  { id: 'orange', displayName: 'Orange League', primaryColour: '#FF5A22' },
  { id: 'yellow', displayName: 'Yellow League', primaryColour: '#FCB812' },
  { id: 'green', displayName: 'Green League', primaryColour: '#AAD81E' },
  { id: 'blue', displayName: 'Blue League', primaryColour: '#00A0D2' },
  { id: 'purple', displayName: 'Purple League', primaryColour: '#9440E8' },
];
